import { FrontendPageContent } from "@/components/frontend/FrontendPageContent";
import { HOME_ORG_PATH } from "@/config/constants";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router";

export const DocumentLibraryLayout = () => {
    const { setBreadcrumbs } = useBreadcrumb();
    const location = useLocation();

    useEffect(() => {
        setBreadcrumbs([
            { label: "Home", path: HOME_ORG_PATH },
            {
                label: "Document Library",
                path: "/organizations/document-library",
            },
        ]);
    }, [location.pathname, setBreadcrumbs]);

    return (
        // [container-type:size] lets DocumentDetailLayout's sticky panel
        // size itself to this scrollport via 100cqh (its host contract).
        <FrontendPageContent className="[container-type:size] flex min-h-0 flex-1 flex-col overflow-x-clip overflow-y-auto pt-4 pb-4 pl-4">
            <Outlet />
        </FrontendPageContent>
    );
};
